
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4066"}},[_c('path',{attrs:{"data-name":"Path 121861","d":"M40 0A40 40 0 110 40 40 40 0 0140 0z","fill":"#dea404","opacity":".15"}}),_c('g',{attrs:{"data-name":"people","fill":"rgba(0,0,0,0)","stroke":"#b28303","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"d":"M49.948 31.919a1.011 1.011 0 00-.317 0 4.316 4.316 0 11.317 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M48.228 44.073a9.407 9.407 0 006.578-1.2c2.354-1.569 2.354-4.141 0-5.71a9.466 9.466 0 00-6.628-1.187"}}),_c('g',{attrs:{"data-name":"Group"}},[_c('path',{attrs:{"data-name":"Vector","d":"M29.932 31.919a1.011 1.011 0 01.317 0 4.316 4.316 0 10-.317 0zM31.652 44.073a9.407 9.407 0 01-6.578-1.2c-2.354-1.569-2.354-4.141 0-5.71a9.466 9.466 0 016.628-1.187"}})]),_c('g',{attrs:{"data-name":"Group"}},[_c('path',{attrs:{"data-name":"Vector","d":"M39.965 44.321a1.011 1.011 0 00-.317 0 4.316 4.316 0 11.317 0zM35.107 49.58c-2.354 1.569-2.354 4.141 0 5.71a9.479 9.479 0 009.717 0c2.354-1.569 2.354-4.141 0-5.71a9.555 9.555 0 00-9.717 0z"}})])])])])
          )
        }
      }
    